export const SaleNote = ({ dark = false, className = "" }) => (
  <p
    data-testid="sale-note"
    className={`mt-3 inline-flex items-center gap-2 text-[12px] font-medium ${dark ? "text-white/70" : "text-ink/60"} ${className}`}
  >
    <span className={`h-1.5 w-1.5 shrink-0 ${dark ? "bg-white/80" : "bg-red"}`} />
    Sprzedaż tylko 9–15 listopada · 30 abonamentów łącznie we wszystkich trzech wariantach
  </p>
);
